<template>
  <div class="row no-gutters row-bordered row-border-light">
  <div class="col-md-10 px-2 py-3">

    <div class="border border-dark">
      <div class="p-1" style="height:85vh; background-color: white">

        <l-map v-if="!tst" :zoom="zoom" :center="center" style="">
          <l-tile-layer :url="url"></l-tile-layer>
          <div v-if="!tst" class="loader"></div>

        </l-map>
        <l-map v-if="tst"
          :zoom="zoom" :center="center" ref="myMap">

          <l-tile-layer :url="url"></l-tile-layer>



          <l-circle-marker ref="circle" v-scroll-to="'#element'"
                          v-for="(j,index) in circleData"
                          :key="index"
                          v-if="j.count !== 0"
                          :lat-lng="[JSON.parse(j.json).coordinates[1], JSON.parse(j.json).coordinates[0]]"
                          :radius="j.count/3+5"
                          @click="Circle(j,index)"
                          v-on:mousemove="listActive(j)"
                          :weight="2"
          />

        </l-map>
      </div>

    </div>
  </div>

    <div class="col-md-2 pt-0 px-1 py-3">
      <b-form-select  v-model="selected" class="mb-3" @change="ChangeCountry">
        <!-- This slot appears above the options from 'options' prop -->
        <template #first>
          <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
        </template>

        <!-- These options will appear after the ones from 'options' prop -->
        <b-form-select-option  :value="3" v-if="group_str.includes('EL') || group_str.includes('view_all')">Greece</b-form-select-option>
        <b-form-select-option  :value="4" v-if="group_str.includes('IT') || group_str.includes('view_all')">Italy</b-form-select-option>
      </b-form-select>
          <ul v-if="selected" class="list-group bg-white border border-dark" style=" overflow:scroll; max-height:84vh; font-size: 13px;" >
            <a v-for="(i, number) in circleData" @click="list(i,number)"
               :key="number"
               v-if="selected === i.country_id && i.count!==0 "
               class="list-group-item list-group-item-action" :id="`index-${number}`"
               :class="{active: activeList===i.municip }">{{i.municip}} : <strong>{{i.count}}</strong></a>

          </ul>
    </div>

    <b-modal id="modal-center" v-model="modalError" centered title="Error" hide-footer>
      <p class="my-4">No Data Available</p>
    </b-modal>
  </div>
</template>

<script>
import {LMap, LTileLayer, LCircleMarker, LPolygon,LControl, LMarker} from 'vue2-leaflet';
import axios from '../axios-auth'
import routes from '../routes/routes'
export default {
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LPolygon,
    LControl,
    LMarker
  },
  data(){
    return{
      modalError:false,
      display:'none',
      selected:null,
      test:2,
      color:'#3388ff',
      activeList:'',
      radius:1,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [43.6659, 17.1937],
      polygon: {
        latlngs: [],
      },
      tst: false,
      Greece_west_nile_virus:'',
      getBounds:'',
      centernew:[],
      memoryOfcolor:[null,null,null],
      memoryOfcolorOnHover:[null,null,null],
      circleData:'',
      group_str:null
    }
  },
  async created(){
    //console.log(this.$store.getters.WestNileVirusData)
    //const Greece_west_nile_virus=await axios.get('http://localhost:7000/west-nile-virus/', {params: {country_id: 3}})
    var Greece_west_nile_virus=null
    const token = localStorage.getItem('token')
    var user =JSON.parse(localStorage.getItem('user'))
    this.group = user.groups
    this.group_str= JSON.stringify(this.group)
    console.log(this.group_str)
    Greece_west_nile_virus=await axios.get('epidemiolocigalData/west-nile-virus/',{params:{group:JSON.stringify(this.group)}, headers: { Authorization: `Bearer ${token}` } })////.catch(error=> routes.replace('/'))
    
    this.circleData=Greece_west_nile_virus.data
    console.log(this.circleData)
    if(!this.circleData.length){
      this.modalError=true
    }
    this.tst=true





  },
  methods:{
    list(i, index){
      this.activeList=i.municip
      const lat=JSON.parse(i.json).coordinates[1]
      const lng=JSON.parse(i.json).coordinates[0]
      this.$refs.myMap.mapObject.panTo([lat, lng])
      this.$refs.myMap.mapObject.fitBounds([[lat+0.3, lng+0.3],[lat-0.3, lng-0.3]])

      this.changeColor(i,index,this.memoryOfcolor,"not")

     // console.log(this.$refs.circle[0])
     // console.log("List Municipality Counters",i)
    },
    Circle(circleData,number){
      //this.selected=circleData.country_id
      //this.$refs.myMap.mapObject.panTo(circleData.latlgn)
      //this.$refs.myMap.mapObject.fitBounds(circleData.bounds)
      this.changeColor(circleData,number,this.memoryOfcolor,"not")
      this.activeList=circleData.municip
      //console.log(this.$el)

      const el = this.$el.querySelector(`#index-${number}`)
      //console.log(el)
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }

    },
    changeColor(circleData,number,colorArray,not){
      if(colorArray[0]===null){
        colorArray.splice(0,1,number)
        this.$refs.circle[number].color='#EC008C'
        //this.$refs.circle[number].color='#EC008C'
       // circleData.color='#e70202'

      }
      else{
        colorArray.splice(1,1,colorArray[0])
        colorArray.splice(0,1,number)
        //this.centernew[colorArray[1]].color='#3388ff'
        //circleData.color='#e70202'

        this.$refs.circle[colorArray[1]].color='#3388ff'
        this.$refs.circle[number].color='#EC008C'

      }
      if(not==="not"){
        //console.log('here')
        this.memoryOfcolor.splice(2,1,number)
        this.memoryOfcolorOnHover.splice(2,1,number)
      }
      if(colorArray[2]!==null){
        //console.log('here2')
        this.$refs.circle[colorArray[2]].color='#e70202'
      }

    },
    ChangeCountry(){

     if(this.selected===4){
       this.$refs.myMap.mapObject.fitBounds([[46.2634502432201,12.0569594997323],[44.6924119881264,11.1465820717025]])
     }else{
       this.$refs.myMap.mapObject.fitBounds([[40.7634502432201,24.8569594997323],[35.5924119881264,20.6465820717025]])

     }

     },
    listActive(j){
      this.selected=j.country_id
    }

  }
}
</script>

<style>
.list-group-item {
  padding: .55rem 1.25rem;
}
.list-group-item-action:hover {
  color: #ec0000;

}
.loader{
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1001;
  background: url('../../public/img/load1.gif') 50% 50% no-repeat rgba(255,193,249,0.5)

}

</style>
